import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class ModalService {
  private reportChangerKey = 'reportChanger';
  private shortcutModalOpen = new BehaviorSubject<boolean>(false);
  private dateModalOpen = new BehaviorSubject<boolean>(false);

  shortcutModalOpen$ = this.shortcutModalOpen.asObservable();
  dateModalOpen$ = this.dateModalOpen.asObservable();

  openShortcutModal() {
    this.shortcutModalOpen.next(true);
  }

  closeShortcutModal() {
    this.shortcutModalOpen.next(false);
  }

  openDateModal() {
    this.dateModalOpen.next(true);
  }

  closeDateModal() {
    this.dateModalOpen.next(false);
  }

  isAnyModalOpen(): boolean {
    return this.shortcutModalOpen.value || this.dateModalOpen.value;
  }

  closeAllModals() {
    this.closeShortcutModal();
    this.closeDateModal();
  }

  getToggleValue(): boolean {
    const storedValue = localStorage.getItem(this.reportChangerKey);
    return storedValue !== null ? JSON.parse(storedValue) : false; // Default to false if not set
  }

  // Set value in localStorage
  setToggleValue(value: boolean): void {
    localStorage.setItem(this.reportChangerKey, JSON.stringify(value));
  }
}
